import { routesConfig } from "config/app-config";
import ApplicationRoles from "constants/ApplicationRoles";
import Statut from "constants/Statut";
import FilterCommandesPage from "components/organisms/FilterCommandesPage";
import { Outlet } from "react-router";
import type { ReactNode } from "react";
import commandesFiltersService from "services/commandesFiltersService";

const AVAILABLE_STATUTS: Array<Statut> = [
  Statut.EN_ATTENTE,
  Statut.REFUSE,
  Statut.EN_PREPARATION,
  Statut.COMMANDE,
  Statut.EN_TRANSIT,
  Statut.PRET_EN_MAGASIN,
  Statut.LIVRE,
];

function ValidatorPage(): ReactNode {
  return (
    <>
      <FilterCommandesPage
        availableStatuts={AVAILABLE_STATUTS}
        defaultStatuts={commandesFiltersService.SST_DEFAULT_STATUTS_FILTER}
        roles={ApplicationRoles.SSTMANAGER}
        hasCommandeLink
        getCommandeUrl={routesConfig.validatorCommande.getParameterPath}
        pageTitle="Commandes à traiter"
      />
      <Outlet />
    </>
  );
}

export default ValidatorPage;
